import FiberManualRecordSharpIcon from '@mui/icons-material/FiberManualRecordSharp';
function color (score){
  let color 
  if(score <=1){
    color = 'rgba(240, 59, 10, 0.6)'
  }
  else if(score <=2){
    color = 'rgba(235, 200, 26, 0.6)'
  }
  else if(score <=3){
    color = 'rgba(54, 162, 235, 0.6)'
  }
  else if(score <=4){
    color = 'rgba(134, 230, 106, 0.6)'
  }
  else if(score <=5){
    color = 'rgba(65, 138, 43, 0.6)'
  }
  return color 

}

function GroupBy(array){
  var fields = Array.prototype.slice.call(arguments, 1);
  var field = fields.shift();

  if(field){

    var groupedArray = [];
    for(let i =0; i < array.length; i++){
      var index = array[i][field];
      groupedArray[index] = groupedArray[index] || [];
      groupedArray[index].push(array[i]);
    }

    for(let i =0; i < groupedArray.length; i++)
      groupedArray[i] = GroupBy.bind(null, groupedArray[i]).apply(null, fields);
    return groupedArray;
  }

  return array;
}


function score_icon(score){
  return (<FiberManualRecordSharpIcon 
  style ={{color: color(score)}}/>)
}

export const season = ['summer', 'kharif','rabi','annual','semi-perennial','perennial']

// export const location_data = {
//     state: 'Madhya Pradesh',
//     district: 'Khargone', 
//     subdistrict: 'Bhikangaon',
//     pincode:'',
//     village: 'Boruth',
//     survey_no: '469/2||479/784/1||467||469/1||468/3||468/1||479/784/2||468/2||484'
//   }

// export const season_crop_cover = [
//     {season:'Summer', crop: false},
//     {season:'Kharif', crop: true},
//     {season:'Rabi', crop: true},
//     {season:'Annual', crop: true},
//     {season:'Semi-perenial', crop: true},
//     {season:'Perennial', crop: false}
//   ]

  export const year_season_yield = [

    {year: '2019-20', season:'Summer', yield_score: 0, irrigation: 0},
    {year: '2019-20', season:'Kharif',  yield_score: 4, irrigation: 4},
    {year: '2019-20',season:'Rabi', yield_score: 5, irrigation: 4},
    {year: '2019-20',season:'Annual', yield_score: 5, irrigation: 4},
    {year: '2019-20',season:'Semi-perenial', yield_score: 5, irrigation: 4},
    {year: '2019-20',season:'Perennial', yield_score: '', irrigation: ''},
    {year: '2020-21', season:'Summer', yield_score: 0, irrigation: 0},
    {year: '2020-21', season:'Kharif',  yield_score: 3, irrigation: 2},
    {year: '2020-21',season:'Rabi', yield_score: 4, irrigation: 3},
    {year: '2020-21',season:'Annual', yield_score: 3, irrigation: 2},
    {year: '2020-21',season:'Semi-perenial', yield_score: 4, irrigation: 4},
    {year: '2020-21',season:'Perennial', yield_score: '', irrigation: ''},
    {year: '2021-22', season:'Summer', yield_score: 0, irrigation: 0},
    {year: '2021-22', season:'Kharif',  yield_score: 4.5, irrigation: 4},
    {year: '2021-22',season:'Rabi', yield_score: 5, irrigation: 5},
    {year: '2021-22',season:'Annual', yield_score: 5, irrigation: 4},
    {year: '2021-22',season:'Semi-perenial', yield_score: 4.5, irrigation: 3},
    {year: '2021-22',season:'Perennial', yield_score: '', irrigation: ''}

  ]
  
  export const season_yield_score = [
    {season: 'summer', crop: false, yield_score: 1, irrigation:3},
    {season:'Kharif', crop: true, yield_score: 4, irrigation:5},
    {season:'Rabi', crop: true, yield_score: 5, irrigation:5},
    {season:'Annual', crop: true, yield_score: 3, irrigation:5},
    {season:'Semi-perenial', crop: true, yield_score: 3, irrigation:5},
    {season:'Perennial', crop: false, yield_score: 4, irrigation:3}
  ]


 export const overallscore = {
  yield_score: 3.0,
  irrigation: 2.0
 }

function data_icon(data){
  let icon_table = []
  for ( let i = 0; i < data.length; i++ )
  {
    let elem = {
      year: data[i].year,
      season: data[i].season,
      yield_score:  score_icon(data[i].yield_score),
      irrigation:  score_icon(data[i].irrigation)
    }
    icon_table.push(elem)
  }
  return icon_table
}

export const year_season_yield_icon = data_icon(year_season_yield)
export const annual_grouped_performance = GroupBy(year_season_yield_icon,"year")




